import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Story } from '@/utils/storiesData';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import StoryCard from '@/components/story/StoryCard';
import HorizontalScroller from '@/components/mobile/HorizontalScroller';
import { storyCategories } from '@/data/storyCategories';
interface CategoryStoryGroup {
  name: string;
  stories: Story[];
}
interface CategoryStoriesSectionProps {
  category: CategoryStoryGroup;
}
const CategoryStoriesSection: React.FC<CategoryStoriesSectionProps> = ({
  category
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const {
    resolvedTheme
  } = useTheme();
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';

  // Determine if this is the Interior Design category
  const isInteriorDesign = category.name.toLowerCase() === 'interior design' || category.name.toLowerCase() === 'interiors';

  // Determine if this is Architecture or Houses on Screen category
  const isArchitectureOrHouses = category.name.toLowerCase() === 'architecture' || category.name.toLowerCase() === 'houses on screen';

  // Keep browse link slugs stable regardless of display title
  const matchedCategory = storyCategories.find(c => c.title.toLowerCase() === category.name.toLowerCase());
  const targetSlug = matchedCategory?.slug || category.name.toLowerCase();

  // Determine number of cards to show
  const cardsToShow = isInteriorDesign ? 2 : isArchitectureOrHouses ? 4 : 3;
  return <div className={cn("py-6")}>
      <div className="max-w-screen-2xl mx-auto pl-4 pr-0 md:px-8 lg:px-12 xl:px-16">
        <div className="flex items-center justify-between mb-4">
          <h2 className={cn("text-2xl font-chroma", textColor)}>
            {category.name}
          </h2>
          <Button variant="link" onClick={() => navigate(`/browse?category=${targetSlug}`)} className={textColor}>
            View All <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>
        
        <div className={cn(isMobile ? 'hidden' : isInteriorDesign ? 'max-w-[1000px] mx-auto flex justify-center gap-8' : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 lg:gap-8')}>
          {category.stories.slice(0, cardsToShow).map(story => <div key={story.id} className={isInteriorDesign ? 'w-[400px]' : ''}>
              <StoryCard story={story} featured={false} aspectRatio="3/2" hideAuthor={true} />
            </div>)}
        </div>
        
        {isMobile && <div className="pl-0 px-0">
            <HorizontalScroller noLeftPadding showNextCard={false} snap>
              {category.stories.slice(0, isInteriorDesign ? 2 : 4).map(story => <StoryCard key={story.id} story={story} featured={false} aspectRatio="3/2" hideAuthor={true} />)}
            </HorizontalScroller>
          </div>}
      </div>
    </div>;
};
export default CategoryStoriesSection;